<template>
  <div>
    <AddAssetCard />
  </div>
</template>
<script>
import AddAssetCard from '@/components/cards/AddAssetCard.vue';

export default {
  name: 'AddAsset',
  components: {
    AddAssetCard
  }
};
</script>
